import classnames from 'classnames';
import { SearchListing } from '@root/types';
import FirstToMarketLabel from './First-to-market-label.png';
import s from './DeprecatedCss.module.less';

class InfoWindowGenerator {
  translate: Function;

  constructor(translate: Function) {
    this.translate = translate;
  }

  /* eslint-disable max-len */
  getPersonIcon = () => `<?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="Layer_1"  x="0px" y="0px"
	 viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#333333;}
</style>
<path class="st0" d="M98.99,84.31c-7.63-18.38-21.7-26.04-32.83-29.2C74.35,49.76,79.78,40.5,79.78,30c0-16.54-13.46-30-30-30
	s-30,13.46-30,30c0,10.27,5.19,19.35,13.09,24.76C15.67,58.6,4.91,68.79,0.16,85.73c-0.89,3.17-0.18,6.59,1.94,9.38
	c2.28,3.01,5.92,4.88,9.5,4.88h76.46c3.8,0,7.54-2.08,9.77-5.42C99.95,91.4,100.37,87.66,98.99,84.31z M29.78,30
	c0-11.03,8.97-20,20-20c11.03,0,20,8.97,20,20s-8.97,20-20,20C38.76,50,29.78,41.03,29.78,30z M89.51,89.03
	C89.1,89.64,88.45,90,88.05,90H11.59c-0.4,0-1.09-0.35-1.53-0.92c-0.22-0.29-0.3-0.54-0.28-0.64c0,0,0,0,0,0
	c2.79-9.96,9.38-23.42,34.31-25.22c1.17-0.08,3.66-0.21,6.33-0.21c2.08,0,4.27,0.08,6.02,0.3c9.08,1.18,25.47,5.98,33.3,24.84
	C89.88,88.45,89.57,88.94,89.51,89.03z"/>
</svg>`;

  getLeftChevron = () => `<svg height="16px" viewBox="0 0 100 100">
    <defs>
        <path d="M37.7040585,50 L1.97702923,87.8063801 C-0.659009742,90.5958394 -0.659009742,95.1184464 1.97702923,97.9079056 C4.6130682,100.697365 8.8869318,100.697365 11.5229708,97.9079056 L52.0229708,55.0507627 C54.6590097,52.2613035 54.6590097,47.7386965 52.0229708,44.9492373 L11.5229708,2.09209442 C8.8869318,-0.697364807 4.6130682,-0.697364807 1.97702923,2.09209442 C-0.659009742,4.88155365 -0.659009742,9.40416064 1.97702923,12.1936199 L37.7040585,50 Z" id="path-1"></path>
    </defs>
    <g id="chevron-left-slate" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="chevron-left" transform="translate(50.000000, 50.000000) scale(-1, 1) translate(-50.000000, -50.000000) translate(23.000000, 0.000000)">
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <use id="Shape" fill="#FFFFFF" fill-rule="nonzero" xlink:href="#path-1"></use>
        </g>
    </g>
</svg>`;

  getRightChevron = () => `<svg height="16px" viewBox="0 0 100 100">
    <defs>
        <path d="M37.7040585,50 L1.97702923,87.8063801 C-0.659009742,90.5958394 -0.659009742,95.1184464 1.97702923,97.9079056 C4.6130682,100.697365 8.8869318,100.697365 11.5229708,97.9079056 L52.0229708,55.0507627 C54.6590097,52.2613035 54.6590097,47.7386965 52.0229708,44.9492373 L11.5229708,2.09209442 C8.8869318,-0.697364807 4.6130682,-0.697364807 1.97702923,2.09209442 C-0.659009742,4.88155365 -0.659009742,9.40416064 1.97702923,12.1936199 L37.7040585,50 Z" id="path-1"></path>
    </defs>
    <g id="chevron-right-slate" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="chevron-right" transform="translate(23.000000, 0.000000)">
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <use id="Shape" fill="#FFFFFF" fill-rule="nonzero" xlink:href="#path-1"></use>
        </g>
    </g>
</svg>`;

  getVtsLogo =
    () => `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100" xml:space="preserve">
    <style>.st1{fill:#5528FF;}</style>
    <path class="st1" d="M50.2 30.2l16.6 11L79 33.1 50.2 13.9 21.4 33.1l12.2 8.1 16.6-11z"/>
    <path class="st1" d="M50.2 65.2L.2 33.8v20.9l50 31.4 50-31.4V33.8l-50 31.4z"/>
  </svg>`;

  getFlexibleSizeAreaIcon =
    () => `<svg viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.20312 10.1114V2.88916H4.80313V10.1114H3.20312Z" fill="#5528FF" />
    <path d="M11.1992 2.88916V10.1114H12.7992V2.88916H11.1992Z" fill="#5528FF" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H16V13H0V0ZM1.6 1.44444V11.5556H14.4V1.44444H1.6Z" fill="#5528FF" />
  </svg>`;
  /* eslint-enable max-len */

  getExclusiveFlag = (listing, totalListings) =>
    listing.isCurrentlyExclusive
      ? `
    <div class="${classnames({
      [s.label]: true,
      [s.single]: totalListings === 1,
    })}" test-id="exclusiveLabel">
      <img src=${FirstToMarketLabel}></img>
    </div>`
      : '';

  getBuildingName = listing => listing.buildingName || '';

  getPhotoUrl = listing => listing.photo.smallPath || '';

  getListingName = listing => listing.name || '';

  getSquareFootageTitle = listing =>
    `<strong>
    ${this.translate('units:area', {
      area: listing.area,
    })}
    </strong>`;

  getFlexibleSizeArea = (listing: SearchListing) =>
    listing.minMaxArea
      ? `<div class="${s.flexibleSizeArea}">
      <div class="${s.flexibleSizeIcon}">
      ${this.getFlexibleSizeAreaIcon()}
      <span class="${s.flexibleAreatext}">${this.translate('units:minMaxArea', {
          minMaxAreaValue: listing.minMaxArea,
        })}</span>
      </div>
      </div>
    `
      : '';

  getMinimuPriceString = listing =>
    listing.smallestPrice && listing.area
      ? `<div class="${s.price}">
        ${this.translate('listing:search:from')}
          <strong>
            ${this.translate('units:pricePerAreaPerPeriod', {
              pricePerAreaPerPeriod: listing.smallestPrice,
            })}
           </strong>
      </div>`
      : '';

  getCapacity = listing => (listing.capacity ? listing.capacity.toLocaleString('en-US') : '');

  getHeader = (currentIndex, totalListings) => {
    if (totalListings === 1) {
      return '';
    }
    return `<div class="${s.infoHeader}">
      <div class="${s.infoListingNavigator}" id="previous-listing">
       ${this.getLeftChevron()}
      </div>
      ${this.translate('listing:search:space_one_of', {
        currentIndex: currentIndex + 1,
        totalListings,
      })}
      <div class="${s.infoListingNavigator}" id="next-listing"">
        ${this.getRightChevron()}
      </div>
    </div>`;
  };

  createInfoWindow = ({
    listing,
    currentIndex,
    totalListings,
  }: {
    listing: SearchListing;
    currentIndex: Number;
    totalListings: Number;
  }) => `
    <div class="${s.infoWindowContainer}" id="truva-info-window">
      ${this.getHeader(currentIndex, totalListings)}
      ${this.getExclusiveFlag(listing, totalListings)}
      <figure>
        <img src="${this.getPhotoUrl(listing)}" />
      </figure>
      <div class="${s.infoTextContainer}">
        <div class="${s.header}">
          <div class="${s.footage}">
            ${this.getSquareFootageTitle(listing)}
          </div>
          <div class="${s.capacity}">
            ${this.getPersonIcon()}
            ${this.getCapacity(listing)}
          </div>
        </div>
        ${this.getFlexibleSizeArea(listing)}
        <div class="${s.detail}">
          ${this.getBuildingName(listing)}
        </div>
        <div class="${s.detail}">
          ${this.getListingName(listing)}
        </div>
        ${this.getMinimuPriceString(listing)}
      </div>
    </div>
  `;
}

export default InfoWindowGenerator;
